<nav (mouseleave)="resetDropdown()" (keyup.escape)="resetDropdown()">
    <div
        class="drop-down-background"
        [style.height]="maxHeight + 'px'"
        [ngClass]="{ 'drop-down-background-active': activeGroupIndex !== null }"
        #dropdownBackground
    ></div>
    <div class="content">
        <ng-container *ngIf="menuGroups | sideAlignment : 'left' as groupsLeft">
            <ng-container
                *ngTemplateOutlet="
                    navigationList;
                    context: {
                        startIndex: 0,
                        groups: groupsLeft,
                        alignment: 'left'
                    }
                "
            ></ng-container>
        </ng-container>
        <ng-container *ngIf="menuGroups | sideAlignment : 'right' as groupsRight">
            <ng-container
                *ngTemplateOutlet="
                    navigationList;
                    context: {
                        startIndex: (menuGroups | sideAlignment : 'left').length || 0,
                        groups: groupsRight,
                        alignment: 'right'
                    }
                "
            ></ng-container>
        </ng-container>
    </div>
</nav>

<ng-template #navigationList let-groups="groups" let-startIndex="startIndex" let-alignment="alignment">
    <ul class="menu-list" *ngIf="groups.length">
        <li
            class="menu-item kk-hover-underline"
            [ngClass]="{ 'menu-item-right': alignment === 'right' }"
            *ngFor="let item of groups; let groupIndex = index"
            (mouseenter)="setDropdown($event, item.hasChildren, startIndex + groupIndex, 250)"
            (keyup.enter)="setDropdown($event, item.hasChildren, startIndex + groupIndex)"
            aria-level="1"
        >
            @if (item.link) {
                <app-link class="menu-link"
                          [link]="item.link"
                          [inlineStyle]="{ paddingBottom: '20px'}"
                          (focusEvent)="setDropdown($event, item.hasChildren,startIndex + groupIndex, $event.type === 'mouseenter' ? 250 : 0)">
                </app-link>
            }
            <div
                class="dropdown"
                [attr.aria-hidden]="activeGroupIndex === null"
                [ngSwitch]="activeGroupIndex"
                #dropdown
            >
                <div
                    class="dropdown-content container"
                    *ngSwitchCase="startIndex + groupIndex"
                    [style.maxHeight]="maxHeight + 'px'"
                    (appNgChecked)="setHeight(dropdown)"
                    @mainMenuFade
                >
                    <hr />
                    <div class="row">
                        <div class="left-column col-8">
                            <div *ngFor="let column of item.children">
                                <ng-container *ngIf="column.contentTypeAlias === columnTypes.LeftColumn">
                                    <div class="row">
                                        <div class="col-4 col-lg-3" *ngFor="let columnGroup of column.children">
                                            <app-main-menu-group [group]="columnGroup"></app-main-menu-group>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                        <div class="col-4">
                            <div *ngFor="let column of item.children">
                                <ng-container *ngIf="column.contentTypeAlias === columnTypes.RightColumn">
                                    <div class="row">
                                        <div class="col-10 offset-2" *ngFor="let columnGroup of column.children">
                                            <app-main-menu-group [group]="columnGroup"></app-main-menu-group>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</ng-template>
